module.exports = __webpack_public_path__ + "static/media/icon-solutions-01.9c1f1d51.svg";